import { Component, Input, OnChanges, SimpleChanges, OnInit, ViewEncapsulation } from '@angular/core';
import { HelperService } from 'src/app/core/services/helper.service';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class RatingComponent implements OnInit, OnChanges {

  @Input() max: number = 5;
  @Input() value: number = 2.5;
  @Input() name: string = new Date().getTime().toString();
  @Input() isReadOnly: boolean = false;

  public ratingArray = [];
  public ratingValue = 0;

  constructor(
    private _helper: HelperService
  ) { }

  ngOnInit(): void {
    this.calculateRatingArrayList();
    this.ratingValue = this._helper.getRoundingValue(this.value);

    console.log("Rating name: => ", this.name, new Date().getUTCMilliseconds())
  }

  ngOnChanges(_changes: SimpleChanges): void {
    for (const _propName in _changes) {
      if (_changes.hasOwnProperty(_propName)) {
        switch (_propName) {
          case "max":
            this.calculateRatingArrayList();
            break;
          case "value":
            this.ratingValue = this._helper.getRoundingValue(_changes.value.currentValue);
            break;
        }
      }
    }
  }

  calculateRatingArrayList = () => {
    this.ratingArray = [];
    for(let i=0; i <= this.max;) {
      this.ratingArray.push(i);
      i += 0.5
    }

    console.log("calculateRatingArrayList: ", this.ratingArray)
  }

}
